const initialState = {
  active: false,
  title: "",
  body: "",
  type: "",
  resolve: null,
  reject: null,
};

const state = Object.assign({}, initialState);

const mutations = {
  SET_MODAL_ACTIVATE: (state, payload) => {
    Object.assign(state, payload);
  },
  SET_MODAL_DEACTIVATE: (state) => {
    state = Object.assign(state, initialState);
  },
};

const actions = {
  SET_MODAL: ({ commit }, { title, body, type }) => {
    //check for the old state if it's equal to the new state
    if (state.active && state.title === title && state.body === body && state.type === type) {
      return;
    }
    return new Promise((resolve, reject) => {
      commit("SET_MODAL_ACTIVATE", {
        active: true,
        title,
        body,
        type,
        resolve,
        reject,
      });
    });
  },
};

export default {
  state,
  mutations,
  actions,
};

